import { Layers, Calculator, ArrowRightLeft, MessageCircle, Share2 } from 'lucide-react'
import { ScenarioMock } from './mocks/ScenarioMock'
import { CalculationMock } from './mocks/CalculationMock'
import { QuoteOrderMock } from './mocks/QuoteOrderMock'
import { CommentsMock } from './mocks/CommentsMock'
import { ClientShareMock } from './mocks/ClientShareMock'

interface Concept {
  id: string
  eyebrow: string
  title: string
  icon: typeof Layers
  body: string
  visual: React.ReactNode
}

const CONCEPTS: Concept[] = [
  {
    id: 'scenario',
    eyebrow: 'Senariýa',
    title: 'Sapar üçin «näme bolsa?» pikiri.',
    icon: Layers,
    body: 'Bir baha — köp plan. Göni, geçiş, bölünen — her birini aýratyn modellaň.',
    visual: <ScenarioMock />,
  },
  {
    id: 'calculation',
    eyebrow: 'Hasaplama',
    title: 'Senariýa — bahalanan.',
    icon: Calculator,
    body: 'Ýangyç, paç, sürüji, marja — setir-setir, üýtgedişiňize görä dessine gaýtadan hasaplanýar.',
    visual: <CalculationMock />,
  },
  {
    id: 'quote-to-order',
    eyebrow: 'Baha → Sargyt',
    title: 'Kabul edilen senariýa sargyda öwrülýär.',
    icon: ArrowRightLeft,
    body: 'Bir basmak — taýýar. Dispetçer we maliýe awtomatiki dowam etdirýär.',
    visual: <QuoteOrderMock />,
  },
  {
    id: 'comments',
    eyebrow: 'Teswirler & Hereket',
    title: 'Bahanyň durýan ýerinde gepleşiň.',
    icon: MessageCircle,
    body: 'Adamlar üçin Teswirler bölümi. Audit yzy üçin Hereket bölümi.',
    visual: <CommentsMock />,
  },
  {
    id: 'client-share',
    eyebrow: 'Müşderä iber',
    title: 'Teklibi paýlaşyň. Olar şol ýerden jogap berýär.',
    icon: Share2,
    body: 'Açyk salgy. Müşderi wariant saýlaýar. Jogaby siziň hereket lentaňyza düşýär.',
    visual: <ClientShareMock />,
  },
]

export function Concepts() {
  return (
    <section id="concepts" className="border-b border-border">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
        <div className="max-w-2xl mb-14">
          <p className="eyebrow text-primary mb-3">Model</p>
          <h2 className="text-[28px] sm:text-[36px] leading-tight font-semibold tracking-tight">
            Bäş pikir bütin işi gurşaýar.
          </h2>
        </div>

        <div className="space-y-16 lg:space-y-24">
          {CONCEPTS.map((c, idx) => (
            <ConceptRow key={c.id} concept={c} reversed={idx % 2 === 1} />
          ))}
        </div>
      </div>
    </section>
  )
}

function ConceptRow({ concept, reversed }: { concept: Concept; reversed: boolean }) {
  const { icon: Icon } = concept
  return (
    <article
      id={concept.id}
      className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center scroll-mt-20"
    >
      <div className={reversed ? 'lg:order-2' : ''}>
        <p className="inline-flex items-center gap-2 eyebrow text-primary mb-3">
          <Icon className="w-3.5 h-3.5" />
          {concept.eyebrow}
        </p>
        <h3 className="text-[24px] sm:text-[28px] leading-tight font-semibold tracking-tight">
          {concept.title}
        </h3>
        <p className="mt-4 text-muted-foreground leading-relaxed">{concept.body}</p>
      </div>
      <div className={reversed ? 'lg:order-1' : ''}>{concept.visual}</div>
    </article>
  )
}
